<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Seção de Conteúdo - Inclusão</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'contentSections'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>
    <form-content-section :btnLabel="btnLabel"></form-content-section>
</span>
</template>

<script>
import FormContentSectionComponent from "./partial/FormContentSectionComponent";

export default {
    name: "AddContentSectionComponent",
    data() {
        return {
            btnLabel: 'Incluir'
        }
    },
    methods: {

    },
    components: {
        formContentSection: FormContentSectionComponent,
    }
};
</script>

<style scoped>

</style>
